import InternalClipboard from './clipboard';
var Clipboard = InternalClipboard;
export default Clipboard;